'use client';

import * as React from 'react';

/**
 * Components optionally rendered inside `EventDialog`. The premium scheduler fills these
 * via the `optionalRenderers` prop on `EventDialogProvider`; community leaves them empty.
 */

export const EventDialogOptionalRenderersContext = /*#__PURE__*/React.createContext({});
if (process.env.NODE_ENV !== "production") EventDialogOptionalRenderersContext.displayName = "EventDialogOptionalRenderersContext";
export function useEventDialogOptionalRenderers() {
  return React.useContext(EventDialogOptionalRenderersContext);
}